import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MessageService, TreeNode } from 'primeng/api';
import { EmployeeDetails } from '../employees-training-plan/models/employee-details';
import { SelectedUserScopesDTO } from '../employees-training-plan/models/selectedUserScopesDTO';
import { UserService } from '../user-profile/user.service';
import { UserProfile } from '../user-profile/models/user-profile';
import { UserProfileConstants } from '../user-profile/user-profile-constants';
import { EqmsScopeManagementService } from '../../../app/shared/services/eqms-scope-management.service';
import { TreeData } from '../../../app/shared/models/TreeData';
import { EmployeesDetailsDto } from '../user-profile/models/employeesDetailsDto';
import { UserProfileSliderComponent } from '../user-profile/user-profile-slider/user-profile-slider.component';
import { delay, forkJoin, Observable, of } from 'rxjs';
import { MySpaceConstants } from '../my-space-constants';
import { formatDate } from '@angular/common';
import { DefaultValueConstants } from '../../shared/constants/default-value-constants';
import { SharedConstants } from '../../../app/shared/constants/shared-constants';
import { UserSkillsByStatusDto } from '../user-profile/models/user-skills-by-status';
import { AuditTrialDetails } from '../../../app/shared/models/audits/audit-trial-details';

@Component({
  selector: 'app-my-employees-profile',
  templateUrl: './my-employees-profile.component.html',
  styleUrls: ['./my-employees-profile.component.scss']
})

export class MyEmployeesProfileComponent implements OnInit{
  toastKey: string = UserProfileConstants.MyEmployeesProfileToastKey;

  ngOnInit(): void {
    this.messageService.clear(this.toastKey);
    this.loadUsersList();
  }

  valueField: string = 'puid';
  labelField: string = 'name';
  employeeDetails: EmployeeDetails[] = [];
  selectedPuid: string | null = null;
  myEmployeesTab: boolean = false;
  puidSelected: boolean = false;
  isTrainingPlanSliderOpen: boolean = false;
  scopesTreeData: TreeNode[] = [];
  userScopes: SelectedUserScopesDTO | undefined;
  ifUserIsSelected : boolean = false;
  userPUID: string | undefined;
  treeData: TreeNode[] = [];
  userTreeData: TreeNode[] = [];
  userProfile: UserProfile = {} as UserProfile;
  files: File[] = [];
  alleQMSScope:any[] = [];
  auditTrailData: AuditTrialDetails[] = [];
  notApplicableText = UserProfileConstants.NotApplicable;
  selectedUser: TreeNode | null = null;
  maxFileSize = MySpaceConstants.Attachment_File_Max_Size;
  userSelected:boolean=false;
  userWithActiveStatusSelected: boolean = false;
  userWithTerminatedStatusSelected: boolean = false;
  userProfileAttachmentMaxLimit= SharedConstants.AttachmentMaxLimit;
  @Input() canAssignSkills = false;
  isAssignSkillsSliderOpen = false;
  isShowUserProfileAuditModal = false;
  userAssignedSkills: UserSkillsByStatusDto = {} as UserSkillsByStatusDto;
  
  @ViewChild(UserProfileSliderComponent) userProfileSlider!:UserProfileSliderComponent;
  userPUIDForEdit:any;
  isUserProfileSliderOpen:boolean = false;

  constructor( private userService: UserService, private eqmsScopeManagementService: EqmsScopeManagementService, private cdr: ChangeDetectorRef,
    private messageService : MessageService){
  }

  loadUsersList() {
    var puid = sessionStorage['puid'] != null ? sessionStorage['puid'] : null;
    this.userService.getUsersForMyEmployeesProfile(puid).subscribe((usersData) => {
      this.userTreeData = this.createEmployeeDetailsTreeNodes(usersData);
    });
  }

  createEmployeeDetailsTreeNodes(employeeDetails: EmployeesDetailsDto[]): TreeNode[] {
    let activeUsersNode: TreeNode = {
      label: DefaultValueConstants.activeUsers_label,
      selectable: false,
      children: [],
    };
  
    let terminatedUsersNode: TreeNode = {
      label: DefaultValueConstants.terminatedUsers_label,
      selectable: false,
      children: [],
    };
  
    employeeDetails.forEach(employee => {
      let nodeLabel = employee.name;
      let formattedDate = this.formatDateToString(employee.terminationDate);
      nodeLabel += formattedDate ? ` (${formattedDate})` : '';
  
      const node: TreeNode = {
        label: nodeLabel,
        style: `color: ${employee.terminationDate != null ? 'red' : 'green'}; font-weight: normal;`
      };
  
      if (employee.terminationDate != null) {
        terminatedUsersNode.children!.push(node);
      } else {
        activeUsersNode.children!.push(node);
      }
    });
  
    return [activeUsersNode, terminatedUsersNode];
  }

  
  formatDateToString(date: Date | null | undefined): string {
    // Return empty string if date is null or undefined or invalid
    if (!date) return ''; 
    return formatDate(date, 'dd-MMM-yyyy', 'en-US');
  }

  handleTreeSelectChange(event: any) {
    // Checking the selected value has status as active or terminated
    if (event && event.node && event.node.parent.label === DefaultValueConstants.activeUsers_label) {
      this.userWithActiveStatusSelected = true;
      this.userWithTerminatedStatusSelected = false;
    }
    else if(event && event.node && event.node.parent.label === DefaultValueConstants.terminatedUsers_label){
      this.userWithActiveStatusSelected = false; 
      this.userWithTerminatedStatusSelected = true;
    }

   //Get the puid from the input
    if (event && event.node && event.node.label) {
      this.selectedPuid = this.extractPUID(event.node.label);
      this.userPUID = this.selectedPuid;
      this.puidChange(); // to get linked, Ancestor & Decendant Scopes for validation
    }
    else {
      this.selectedPuid = null;
    }
  }
 ngOnDestroy(): void {
  // Clear messages when component is destroyed
  this.messageService.clear(this.toastKey);
}
  private extractPUID(node: string) {
    const startIndex = node.indexOf('(') + 1;
    const endIndex = node.indexOf(')', startIndex);
    return node.substring(startIndex, endIndex);
  }

  puidChange(){
    this.myEmployeesTab = true;
    this.puidSelected = this.selectedPuid != null ? true : false;
    if(this.selectedPuid != null){
      this.loadUserProfile();
    }
  }


  async reloadUserData() {
    this.isUserProfileSliderOpen = false;
    this.cdr.detectChanges();
    await this.delay(3000);  // Introducing delay to fetch the latest updated data consistently
    this.loadUserProfile();
  }
  
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  

  openAssignSkillsSlider(): void {
    this.isAssignSkillsSliderOpen = true;
  }

  closeAssignSkillsSlider(isClosed: boolean): void {
    this.isAssignSkillsSliderOpen = !isClosed;
  }

  loadUserProfile(){
    this.userSelected = false;
    this.treeData = [];
    if(this.selectedPuid != null){
       forkJoin([
      this.userService.getUserByPuid(this.selectedPuid),
      this.userService.getUserAssignedSkills(this.selectedPuid)
    ]).subscribe({
      next: ([userProfileDetails, userSkills]) => {
        this.userProfile = userProfileDetails;
        this.userAssignedSkills = userSkills || this.createEmptySkillsDto();
        
        if(this.userProfile.directReporties === null 
          ||this.userProfile.directReporties === undefined 
          || this.userProfile.directReporties?.length === 0){
          this.userProfile.directReporties = [];
          this.userProfile.directReporties.push(this.notApplicableText);
        }
        this.userSelected = true;
        this.loadeQMSScope();
      },
      error: (error) => {
        // Load profile even if skills fail
        this.userService.getUserByPuid(this.selectedPuid!).subscribe((userProfileDetails) => {
          this.userProfile = userProfileDetails;
          this.userAssignedSkills = this.createEmptySkillsDto();
          
          if(this.userProfile.directReporties === null 
            ||this.userProfile.directReporties === undefined 
            || this.userProfile.directReporties?.length === 0){
            this.userProfile.directReporties = [];
            this.userProfile.directReporties.push(this.notApplicableText);
          }
          this.userSelected = true;
          this.loadeQMSScope();
        });
      }
    });
    }
  }

  /// <summary>
  /// Creates an empty UserSkillsByStatusDto structure to prevent template errors.
  /// </summary>
  private createEmptySkillsDto(): UserSkillsByStatusDto {
    return {
      earned: [],
      pendingAcknowledgement: [],
      pendingVerification: [],
      removed: []
    };
  }
  
loadeQMSScope(){
  this.eqmsScopeManagementService.getEQMSScope().subscribe((eQMSScope) => {
    this.alleQMSScope = eQMSScope;
    //If both primary eQMSScope and selectede QMSScope are null - (in terminated User Condition). no need to construct tree Node for Scopes
    if(this.userProfile.primaryeQMSScopeId !== null || (Array.isArray(this.userProfile.selectedeQMSScopeIds) && this.userProfile.selectedeQMSScopeIds.length > 0)){ 
      this.treeData.push({
        label: eQMSScope.eQMSScopeName,
        icon: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === eQMSScope.eQMSScopeId) ? UserProfileConstants.PrimaryeQMSScopeIcon : undefined,
        styleClass: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === eQMSScope.eQMSScopeId)
          || this.userProfile.selectedeQMSScopeIds?.some(e => e === eQMSScope.eQMSScopeId)
          ? UserProfileConstants.SelectedeQMSScopeStyleClass
          : UserProfileConstants.UnselectedeQMSScopeStyleClass,

        children: eQMSScope.children
          ? this.updateTreeNodes(eQMSScope.children)
          : undefined,
        expanded: true
      });
    }
  });
}

private updateTreeNodes(nodes: any): TreeData[] {
  let children: TreeNode[] = [];
  nodes.forEach((childNode: any) => {
    // Check if this node or its children should be loaded
    if (this.shouldLoadSiblingNodes(childNode) || (childNode.children && this.shouldLoadChildrenNodes(childNode.children))) {
      children.push({
        label: childNode.eQMSScopeName,
        icon: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === childNode.eQMSScopeId)
          ? UserProfileConstants.PrimaryeQMSScopeIcon : undefined,
        styleClass: ( this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === childNode.eQMSScopeId)
          || this.userProfile.selectedeQMSScopeIds?.some(e => e === childNode.eQMSScopeId)
          ? UserProfileConstants.SelectedeQMSScopeStyleClass
          : UserProfileConstants.UnselectedeQMSScopeStyleClass,
        children: childNode.children && this.shouldLoadChildrenNodes(childNode.children)
          ? this.updateTreeNodes(childNode.children)
          : undefined,
        expanded: true
      });
    }
  });
  return children;
}

shouldLoadChildrenNodes(nodes: any[]): boolean {
  let shouldLoad = false;

  // Loop through the children and check if any of the data meet the criteria to load
  for (let i = 0; i < nodes.length; i++) {
    const childNode = nodes[i];
    if (( this.userProfile.primaryeQMSScopeId !== null && childNode.eQMSScopeId === this.userProfile.primaryeQMSScopeId)
      || this.userProfile.selectedeQMSScopeIds?.includes(childNode.eQMSScopeId)) {
      shouldLoad = true;
      break;
    } else if (childNode.children !== undefined && childNode.children !== null) {
      // check child nodes recursively
      if (this.shouldLoadChildrenNodes(childNode.children)) {
        shouldLoad = true;
        break;
      }
    }
  }

  return shouldLoad;
}

shouldLoadSiblingNodes(node: any): boolean {
  // check if the node should be loaded
  return (this.userProfile.primaryeQMSScopeId !== null && node.eQMSScopeId === this.userProfile.primaryeQMSScopeId)
    || (this.userProfile.selectedeQMSScopeIds?.includes(node.eQMSScopeId) ?? false);
}
  
  editUserProfile()
  {
    this.isUserProfileSliderOpen = !this.isUserProfileSliderOpen;
    this.userPUIDForEdit = this.selectedPuid;
    this.userProfileSlider.getUserProfileDataForEdit(this.userPUIDForEdit);
  }

uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
  this.files = [...this.files, ...uploadedFiles];
  
  uploadedFiles.forEach((file) => {
    const modifiedFile = new File(
      [file], 
      this.selectedPuid! + '/' + file.name, 
      { type: file.type }
    );
    
    this.userService.uploadFile(modifiedFile, UserProfileConstants.UserProfileAttachmentFolderName)
      .subscribe({
        next: (response) => {
          const attachmentDetails = {
            attachmentFileType: response.fileExtension,
            fileId: response.fileId,
            attachmentFilePath: modifiedFile.name,
            attachmentFileName: file.name,
          };
          
          if (this.selectedPuid != null) {
            this.userService.addAttachment(this.selectedPuid, attachmentDetails)
              .subscribe({
                next: () => {
                  // Get attachment details, and reload data on the screen
                  this.reloadAttachments();
                },
                error: (err) => {
                  const validationMessage = `Failed to add attachment: ${file.name}`;
                  this.messageService.add({
                    key: this.toastKey,
                    severity: UserProfileConstants.Severity_Err,
                    summary: validationMessage,
                    detail: err.message || 'Failed to add attachment details',
                    sticky: true
                  });
                }
              });
          }
        },
        error: (err) => {
          const validationMessage = `Failed to upload file: ${file.name}`;
          const serviceErrorMessage =
            (typeof err === 'string' ? err : null)
            || err?.error?.errorMessage
            || err?.error?.detail
            || err
            || validationMessage;

          this.messageService.add({
            key: this.toastKey,
            severity: UserProfileConstants.Severity_Err,
            summary: validationMessage,
            detail: serviceErrorMessage,
            sticky: true
          });
        }
      });
  });
  
  const fileNames = uploadedFiles.map((i) => i.name);
  return of(fileNames).pipe(delay(3000));
};

  private reloadAttachments(){
    setTimeout(()=>{
      if(this.selectedPuid != null){
        this.userService.getAttachmentsForUser(this.selectedPuid).subscribe((result)=>{
          this.userProfile.attachments = result;
        })
      }
    }, 3000);
  }

openUserProfileAuditModal(){
  if(this.selectedPuid != null){
    this.auditTrailData = [];
    this.userService.getUserProfileAuditTrail(this.selectedPuid).subscribe({
      next: (result) => {
        this.auditTrailData = result;
        this.isShowUserProfileAuditModal = true;
      },
      error: () => {
        this.messageService.add({
          key: this.toastKey,
          severity: UserProfileConstants.Severity_Err,
          summary: UserProfileConstants.UserProfile_Audit_Load_Failed,
          sticky: true
        });
      }
    });
  }
}

closeUserProfileAuditModal(isClosed: boolean): void {
  if (isClosed) {
    this.isShowUserProfileAuditModal = false;
  }
}

}
